import React, { createContext, useEffect, useState } from 'react'
import "../App.css";


export const UserContext = createContext();

export const UserProvider = ({ children, appConfig }) => {
    const [isLogin, setIsLogin] = useState(false);
    const [captcha, setCaptcha] = useState(false);
    const [config, setConfig] = useState(appConfig || null);

    return (
        <UserContext.Provider value={{isLogin, setIsLogin, captcha, setCaptcha, config }}>
            {children}
        </UserContext.Provider>
    );

};
